"use client";

import { div } from "framer-motion/client";
import "./PageLoading.css";

export default function PageLoading() {
  return (
    <div className="white-patch-loading"></div>
    // <div className="page-shimmer ">
    //   {/* Hero */}
    //   <div className="shimmer hero" />

    //   {/* Content */}
    //   <div className="main-container">
    //     <div className="shimmer-container">
    //       <div className="shimmer title" />
    //       <div className="shimmer text" />
    //       <div className="shimmer text short" />

    //       <div className="shimmer-grid">
    //         <div className="shimmer card" />
    //         <div className="shimmer card" />
    //         <div className="shimmer card" />
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
}
